import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ColorLine } from "./colorLineComponent";
export class Color4LineComponent extends React.Component {
    render() {
        const props = this.props;
        return _jsx(ColorLine, { ...props });
    }
}
//# sourceMappingURL=color4LineComponent.js.map